<template>
    <div id="r2s3">
        <h2 class="title">
            {{ $t('f_r2s3_title') }}
        </h2>

        <p class="subtitle-text">
            {{ $t('f_r2s3_subtitle') }}
        </p>

        <div class="own-input upload-wrap">
            <div>
                {{ $t('f_upoad_photo_id_label') }}
            </div>
            <documents-form :list="passports" name="passports" doc_type="0">
                {{ $t('f_upoad_photo_id_btn') }}
            </documents-form>
        </div>

        <server-errors v-if="serversErrors" :message="serversErrors" />
        <div class="own-input next-prev-wrap">
            <div class="btn btn-link prev" @click="prevStep">
                &#10092; {{ $t('f_back') }}
            </div>
            <div :class="['btn btn-orange', {'invalid': formIsInvalid(), 'progress': loading}]" @click="next">
                <span v-show="!loading">{{ $t('f_continue') }} &#10093;</span>
                <div v-if="loading" class="spinner">
                    <div class="rect1" />
                    <div class="rect2" />
                    <div class="rect3" />
                    <div class="rect4" />
                    <div class="rect5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import formNavMixin from '../mixins/formNavMixin'
  import DocumentsForm from '../common/DocumentsForm'

  export default {
    components: { DocumentsForm },
    mixins: [formNavMixin],
    data() {
      return {
        module: 'round2'
      }
    },
    computed: {
      ...mapGetters({
        passports: 'documents/passports'
      })
    },
    methods: {
      next(){
        this.formSubmittion({scope: `*`, formSelector: '#r2s3'}).then(({success, fail}) => {
          this.$store.dispatch("round2/putAuthorization", this.$store.getters['round2/r2s3FormData']).then(()=> {
            this.$store.commit('round2/NEXT_STEP')
            success()
          }).catch((response) => {
            fail(response)
          })
        })
      },
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  #r2s3 {
    .title {
      position: relative;

      .info-tip {
        > .icon {
          color: $gray_b;

          &:after {
            top: 24px;
            right: 0;
          }
        }

        .content {
          top: 34px;
          text-align: left;
        }
      }
    }

    .subtitle-text {
      font-size: 15px;
      text-align: center;
      margin-bottom: 35px;

      html.tablet &, html.desktop & {
        margin-bottom: 50px;
      }
    }

    .upload-wrap {
      margin-top: 30px;
      margin-bottom: 40px;

      .content {
        bottom: 96px;
      }
    }
  }
</style>
